module.exports = __webpack_public_path__ + "img/huadongzhou.prt.36af48cd.jpg";